import router from "~/router";

function applySafeHtml(el, value) {
  el.innerHTML = value;
  el.querySelectorAll(".custom-link").forEach((link) => {
    link.addEventListener("click", (e) => {
      const path = link.getAttribute("data-link");

      if (path) {
        e.preventDefault();
        router.push(path);
      }
    });
  });
}

export default {
  mounted(el, binding) {
    applySafeHtml(el, binding.value);
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      applySafeHtml(el, binding.value);
    }
  }
};
